import { Button } from "components/LEGACY/styled-components/Buttons"
import { Card, CardBody } from "components/LEGACY/styled-components/Cards"
import { Column, Flex } from "components/LEGACY/styled-components/Flex"
import NewNewsletter from "components/marketing/admin/Newsletter/NewNewsletter"
import Overview from "components/marketing/admin/Newsletter/Overview"
import CopyableString from "components/utils/CopyableString"
import { useShop } from "hooks/firestore/simple/useShop"
import { useHost } from "hooks/misc/useHost"
import { useEffect, useState } from "react"
import { functions } from "../../../../firebase/firebase"

export default function NewsletterSettings() {
  const [view, setView] = useState("overview")
  const [countSubscriber, setCountSubscriber] = useState(-1)

  const [editingNewsletterId, setEditingNewsletterId] = useState<string | null>(null)

  const shop = useShop()
  const { origin } = useHost()

  const refreshNewsletterCount = async () => {
    if (!shop) {
      return
    }
    const subscription = await functions.httpsCallable("groupNL-getNewsletterCount")({
      shopId: shop._ref.id,
    })
    setCountSubscriber(subscription.data)
    return
  }
  useEffect(() => {
    refreshNewsletterCount()
  }, [])

  const startEditingNewsletter = (id: string) => {
    setView("new")
    setEditingNewsletterId(id)
  }

  const backToOverview = () => setView("overview")

  const newsletterUrl = shop && origin ? `${origin}/${shop.shorthand}/newsletter` : ""

  return (
    <Flex>
      <Column width="100%" padding="1rem 0 0 0">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            margin="0"
            ghost={view !== "overview"}
            success={view === "overview"}
            onClick={() => setView(view === "overview" ? "new" : "overview")}
          >
            {view === "overview" ? "+ Neuer Newsletter" : "abbrechen"}
          </Button>
          {countSubscriber >= 0 && (
            <h6 style={{ margin: "0.5rem" }} onClick={refreshNewsletterCount}>
              {countSubscriber} Abonnenten
            </h6>
          )}
        </div>
      </Column>

      {/* Newsletter URL Section */}
      {shop?.newsletterSignup?.active && newsletterUrl && (
        <Column width="100%" padding="1rem 0 0 0">
          <Card>
            <CardBody>
              <h4 style={{ margin: "0 0 0.5rem 0" }}>Newsletter-Anmeldung für Social Media</h4>
              <p style={{ margin: "0 0 1rem 0", color: "#666" }}>
                Teile diesen Link auf deinen Social Media Kanälen, damit sich Kunden direkt für deinen Newsletter
                anmelden können:
              </p>
              <CopyableString stringToCopy={newsletterUrl} />
              <p style={{ margin: "0.5rem 0 0 0", fontSize: "0.9rem", color: "#888" }}>
                Die Seite verwendet automatisch dein Shop-Design und deine Farben.
              </p>
            </CardBody>
          </Card>
        </Column>
      )}

      <Column width="100%" padding="1rem 0">
        <Card>
          <CardBody>
            {view === "new" && <NewNewsletter {...{ backToOverview, editingNewsletterId }} />}
            {view === "overview" && <Overview {...{ backToOverview, startEditingNewsletter }} />}
          </CardBody>
        </Card>
      </Column>
    </Flex>
  )
}
